import { Pipe, PipeTransform } from '@angular/core';
import { PerareFeature } from '../../../../shared/services/api/listing-api.types';
import {
  centroid,
  Feature,
  FeatureCollection,
  featureCollection,
  Point,
  point,

} from '@turf/turf';
import { polygon } from '@turf/helpers';
import { SegmentGeom } from '../../../../components/plot-profile-x/data-access/profile.service';

@Pipe({
  name: 'polygonToVertexLabelsArray',
  standalone: true,
})
export class PolygonToVertexLabelsArrayPipe implements PipeTransform {
  transform(
    features: PerareFeature[],
    frontlineData: { segment: SegmentGeom; feature: FeatureCollection } | null,
  ) {
    const points: Feature<Point, any>[] = features.reduce(
      (acc, current) => {
        // Обрабатываем только полигоны
        const geometry = current.geometry as any;
        if (geometry.type !== 'Polygon') {
          return acc;
        }
        let points: Feature<Point, any>[] = [];
        const turfPolygon = polygon(geometry.coordinates);
        const turfCenter = centroid(turfPolygon);
        const centerCoords = turfCenter.geometry.coordinates;

        geometry.coordinates.slice(0, 1).forEach((positions: any) => {
          const offsettedPoints: Feature<Point, any>[] = positions
            .map((it: any) => point(it))
            .map((it: Feature<Point, any>, index: number) => {
              // Координаты первой и второй точек
              const lng1 = centerCoords[1];
              const lat1 = centerCoords[0];
              const lng2 = it.geometry.coordinates[1];
              const lat2 = it.geometry.coordinates[0];

              // Смещение текста от второй точки
              const d = 1;

              // Вычисление угла наклона с учетом радиан
              const theta = Math.atan2(lat2 - lat1, lng2 - lng1);

              // Смещение в пикселях относительно второй точки
              const xOffset = d * Math.sin(theta); // Используем синус для оси X
              const yOffset = -d * Math.cos(theta); // Используем косинус для оси Y и инвертируем

              // Итоговый оффсет
              const offset = [xOffset, yOffset];

              return point(it.geometry.coordinates, {
                index: index + 1,
                'text-offset': offset,
                color: '#18A0FB',
              });
            });

          points.push(...offsettedPoints.slice(0, offsettedPoints.length - 1));
        });

        return [...acc, ...points];
      },
      [] as Feature<Point, any>[],
    );

    if (frontlineData) {
      try {
        if (frontlineData.segment) {
          const segment = frontlineData.segment;

          if (segment.type === 'LineString') {
            points.forEach((point) => {
              const isPointInFrontline = segment.coordinates.find((it) => {
                return (
                  it[0] === point.geometry.coordinates[0] && it[1] === point.geometry.coordinates[1]
                );
              });

              if (isPointInFrontline) {
                point.properties.color = '#E04F76';
              }
            });
          }

          if (segment.type === 'MultiLineString') {
            points.forEach((point) => {
              const isPointInFrontline = segment.coordinates.some((it) =>
                it.find((it) => {
                  return (
                    it[0] === point.geometry.coordinates[0] &&
                    it[1] === point.geometry.coordinates[1]
                  );
                }),
              );

              if (isPointInFrontline) {
                point.properties.color = '#E04F76';
              }
            });
          }
        }
      } catch (e) {
        console.error(e);
      }
    }
    return featureCollection(points);
  }
}
